import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../components/Component';
import moment from 'moment';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import { RETRIEVE_SPECIFIC_TENANT_SALES_REP_DETAILS_API, RETRIEVE_TENANT_SYSTEM_BRANDS_API, TENANT_TOGGLE_SALES_REP_ALLOWED_BRAND_API } from '../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_sales_reps_details, loading_retrieve_sales_reps_details, reset_retrieve_sales_reps_details, success_retrieve_sales_reps_details } from '../../../reducers/auth_tenant/retrieve_sales_reps_details_Slice';
import { RETRIEVE_BRANDS_ERROR_MSG, RETRIEVE_BRANDS_SUCCESS_MSG, RETRIEVE_SALES_REP_DETAIL_ERROR_MSG, RETRIEVE_SALES_REP_DETAIL_SUCCESS_MSG, TENANT_TOGGLE_SALES_REP_BRAND_ERROR_MSG, TENANT_TOGGLE_SALES_REP_BRAND_SUCCESS_MSG } from '../../../utils/error_success_messages';
import * as app_consts from "../../../utils/app_consts";
import { useSelector } from 'react-redux';
import { addThreeDots, formatNumber, formatToSentenceCase, messageToast } from '../../../utils/Utils';
import { fail_retrieve_brands_list, loading_retrieve_brands_list, reset_retrieve_brands_list, success_retrieve_brands_list } from '../../../reducers/auth_tenant/retrieve_brands_list_Slice';
import CardTabs from '../../components/cards/CardTabs';
import { Alert, Badge, Input, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import AgencyViewSalesRepDetailsModal from '../../../components/modal/AgencyViewSalesRepDetailsModal';
import { Link } from 'react-router-dom';
import LabelText from '../../components/text/LabelText';
import ViewSalesRepBudgetAllocationDetails from '../../../components/modal/ViewSalesRepBudgetAllocationDetails';
import { fail_tenant_toggle_sales_rep_brand, loading_tenant_toggle_sales_rep_brand, reset_tenant_toggle_sales_rep_brand, success_tenant_toggle_sales_rep_brand } from '../../../reducers/auth_tenant/tenant_toggle_sales_rep_brand_Slice';
import ViewSalesRepsAllowedBrandsModal from '../../../components/modal/ViewSalesRepsAllowedBrandsModal';
import { motion } from 'framer-motion';
import DatePicker from 'react-datepicker';
import SalesRepDetailsOrdersReportsSummary from './data/SalesRepDetailsOrdersReportsSummary';
import SalesRepDetailsOrderReportsProducts from './data/SalesRepDetailsOrderReportsProducts';
import SalesRepDetailsOrderReportsOrders from './data/SalesRepDetailsOrderReportsOrders';

const initialState = { initial_start_date: moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"), initial_end_date: moment().format("YYYY-MM-DD HH:mm:ss"), order_start_date: moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"), order_end_date: moment().format("YYYY-MM-DD HH:mm:ss") };

const SalesRepsDetails = ({ tenant_info, user_info }) => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const [brands, setBrands] = useState([]);
  const [brands_loading, setBrandsLoading] = useState(false);
  const [activeCardTab, setActiveCardTab] = useState("Main Info");
  const [selectedToggleRole, setSeletedToggleRole] = useState("");
  const [toggle_loading, setToggleLoading] = useState(false);
  const [toggle_role_error, setToggleRoleError] = useState("");
  const [currentAgencyPage, setCurrentAgencyPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [view_sales_rep_modal, setViewSalesRepModal] = useState(false);
  const [sales_rep_id, setSalesRepId] = useState("");
  const [current_orders_data, setCurrentOrdersData] = useState([]);
  const [current_orders_page, setCurrentOrdersPage] = useState(1);
  const [ordersSearchTerm, setOrdersSearchTerm] = useState("");
  const [sm, updateSm] = useState(false);
  const [current_allocations_page, setCurrentAllocationsPage] = useState(1);
  const [current_audits_page, setCurrentAuditsPage] = useState(1);
  const [selected_audit, setSelectedAudit] = useState("");
  const [audit_trails_modal, setAuditTrailsModal] = useState(false);
  const [view_sales_rep_budget_allocation_details, setViewSalesRepBudgetAllocationDetails] = useState(false);
  const [selected_sales_rep_budget_allocation, setSelectedSalesRepBudgetAllocationDetails] = useState([]);
  const [view_sales_rep_allowed_brands_modal, setSalesRepAllowedBrandsModal] = useState(false);
  const [selected_allowed_brand, setSelectedAllowedBrand] = useState("");
  const [form_data, setFormData] = useState(initialState);
  const [selectedRange, setSelectedRange] = useState([
    moment().startOf("month").toDate(),
    moment().toDate(),
  ]);
  const [retrieval_type, setRetrievalType] = useState(0);
  const [retriaval_loading, setRetrievalLoading] = useState(false);
  const [retrievalError, setRetrievalError] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [activeOrderReportTab, setActiveOrderReportTab] = useState("Summary");

  const tabs = [
    {
      tabName: "Main Info"
    },
    {
      tabName: "Brands"
    },
    {
      tabName: "Agencies"
    },
    {
      tabName: "Orders"
    },
    {
      tabName: "Orders Reports"
    },
    {
      tabName: "Budget Allocations"
    },
    {
      tabName: "Audit Trails"
    },
  ];

  const orders_reports_tabs = [
    {
      tabName: "Summary"
    },
    {
      tabName: "Products"
    },
    {
      tabName: "Orders"
    },
    // {
    //   tabName: "Dispatches"
    // }
  ];

  useEffect(() => {
    retrieve_page_data();
  }, []);

  const retrieve_page_data = () => {
    setError("");
    setRetrievalError("");


    // Get the browser's timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Get the browser's timezone offset in minutes
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = Math.abs(offsetMinutes) / 60;
    const offsetSign = offsetMinutes > 0 ? "-" : "+";
    const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;

    dispatch(tenant_auth_actions_helper(loading_retrieve_sales_reps_details, success_retrieve_sales_reps_details, fail_retrieve_sales_reps_details, RETRIEVE_SALES_REP_DETAIL_ERROR_MSG, RETRIEVE_SALES_REP_DETAIL_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_SPECIFIC_TENANT_SALES_REP_DETAILS_API}/${id}/${form_data.order_start_date}${formattedOffset}/${form_data.order_end_date}${formattedOffset}`));
    // Retrieve Brands
    dispatch(tenant_auth_actions_helper(loading_retrieve_brands_list, success_retrieve_brands_list, fail_retrieve_brands_list, RETRIEVE_BRANDS_ERROR_MSG, RETRIEVE_BRANDS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_SYSTEM_BRANDS_API}`));
  };


  // Listener
  const retrieve_sales_reps_details_listener = useSelector((state) => state.retrieve_sales_reps_details.retrieve_sales_reps_details);

  useEffect(() => {
    if (retrieve_sales_reps_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_sales_reps_details_listener.status === app_consts.LOADING)
      {
        setError("");
        setRetrievalError("");
        if (retrieval_type === 0)
        {
          setLoading(true);
        }
        else
        {
          setRetrievalLoading(true);
        }
      } else
      {
        if (retrieve_sales_reps_details_listener.status === app_consts.FAIL)
        {
          if (retrieval_type === 0)
          {
            setError(retrieve_sales_reps_details_listener?.message);
          }
          else
          {
            setShowPicker(!showPicker);
            setRetrievalError(retrieve_sales_reps_details_listener?.message);
          }
          setLoading(false);
          setRetrievalLoading(false);
          messageToast(retrieve_sales_reps_details_listener.message, app_consts.FAIL);
        } else if (retrieve_sales_reps_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_sales_reps_details_listener.data);
          setCurrentOrdersData(retrieve_sales_reps_details_listener.data?.orders || []);
          const timer = setTimeout(() => {
            setLoading(false);
            setRetrievalType(0);
            setRetrievalLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_sales_reps_details());
      }
    }
  }, [retrieve_sales_reps_details_listener]);

  const retrieve_brands_list_listener = useSelector((state) => state.retrieve_brands_list.retrieve_brands_list);

  useEffect(() => {
    if (retrieve_brands_list_listener.status !== app_consts.IDLE)
    {
      if (retrieve_brands_list_listener.status === app_consts.LOADING)
      {
        setBrandsLoading(true);
      } else
      {
        setBrandsLoading(false);
        if (retrieve_brands_list_listener.status === app_consts.FAIL)
        {
          messageToast(retrieve_brands_list_listener.message, app_consts.FAIL);
        } else if (retrieve_brands_list_listener.status === app_consts.SUCCESS)
        {
          setBrands(retrieve_brands_list_listener.data?.settings);
        }
        dispatch(reset_retrieve_brands_list());
      }
    }
  }, [retrieve_brands_list_listener]);

  const indexOfLastAgencyItem = currentAgencyPage * itemPerPage;
  const indexOfFirstAgencyItem = indexOfLastAgencyItem - itemPerPage;
  const currentAgencyItems = page_data?.agencies?.slice(indexOfFirstAgencyItem, indexOfLastAgencyItem);

  // Save page to localStorage
  const agencies_paginate = (pageNumber) => {
    setCurrentAgencyPage(pageNumber);
  };


  const orders_paginate = (pageNumber) => {
    setCurrentOrdersPage(pageNumber);
  };

  const open_view_sales_rep_modal = (id) => {
    setSalesRepId(id);
    setViewSalesRepModal(true);
  };

  const close_view_sales_rep_modal = () => {
    setSalesRepId("");
    setViewSalesRepModal(false);
  };

  // Filtering by search
  useEffect(() => {
    filtered_orders(ordersSearchTerm);
  }, [ordersSearchTerm, page_data?.orders]);

  const filtered_orders = (searchItem) => {
    if (searchItem)
    {
      setCurrentOrdersPage(1);
      let displayedOrders = page_data?.orders?.filter((item) => {
        const combinedParams = [
          item?.sales_rep?.name,
          item.order_ref_number,
          item.order_name,
          item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
          item.status?.replace(/_/g, " ").toUpperCase(),
        ]
          .join(" ")
          .toLowerCase();
        return combinedParams.includes(searchItem.toLowerCase());
      });
      setCurrentOrdersData(displayedOrders);
    } else
    {
      setCurrentOrdersData(page_data?.orders);
      setCurrentOrdersPage(1);
    }
  };

  // Pagination
  const indexOfLastOrderItem = current_orders_page * itemPerPage;
  const indexOfFirstOrderItem = indexOfLastOrderItem - itemPerPage;
  const currentOrderItems = current_orders_data?.slice(indexOfFirstOrderItem, indexOfLastOrderItem);


  // Pagination
  const indexOfLastAllocationItem = current_allocations_page * itemPerPage;
  const indexOfFirstAllocationItem = indexOfLastAllocationItem - itemPerPage;
  const currentAllocationItems = page_data?.budget_allocations?.slice(indexOfFirstAllocationItem, indexOfLastAllocationItem);


  // Pagination
  const indexOfLastAuditItem = current_allocations_page * itemPerPage;
  const indexOfFirstAuditItem = indexOfLastAuditItem - itemPerPage;
  const currentAuditItems = page_data?.audit_trails?.slice(indexOfFirstAuditItem, indexOfLastAuditItem);


  const allocations_paginate = (pageNumber) => {
    setCurrentAllocationsPage(pageNumber);
  };

  const audits_paginate = (pageNumber) => {
    setCurrentAuditsPage(pageNumber);
  };

  const view_audit_trail = (audit_trail_id) => {
    setAuditTrailsModal(true);
    // Filter Audit
    const filtered_audit = page_data?.audit_trails?.filter((audit) => audit?.id === audit_trail_id);
    setSelectedAudit(filtered_audit[0]);
  };

  const close_view_audit_modal = () => {
    setAuditTrailsModal(false);
    setSelectedAudit("");
  };

  const open_view_sales_rep_budget_allocation_details = (sba_id) => {
    setViewSalesRepBudgetAllocationDetails(true);
    // Filter Audit
    setSelectedSalesRepBudgetAllocationDetails(sba_id);
  };

  const close_view_sales_rep_budget_allocation_details = () => {
    setViewSalesRepBudgetAllocationDetails(false);
    setSelectedSalesRepBudgetAllocationDetails("");
  };

  const toggle_brand = (role) => {
    setSeletedToggleRole(role);
    setToggleRoleError("");
    dispatch(tenant_auth_actions_helper(loading_tenant_toggle_sales_rep_brand, success_tenant_toggle_sales_rep_brand, fail_tenant_toggle_sales_rep_brand, TENANT_TOGGLE_SALES_REP_BRAND_ERROR_MSG, TENANT_TOGGLE_SALES_REP_BRAND_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_TOGGLE_SALES_REP_ALLOWED_BRAND_API}`, { sales_rep_id: page_data?.sales_rep?.id, brand: role }));
  };

  // Listener
  const tenant_toggle_sales_rep_brand_listener = useSelector((state) => state.tenant_toggle_sales_rep_brand.tenant_toggle_sales_rep_brand);

  useEffect(() => {
    if (tenant_toggle_sales_rep_brand_listener.status !== app_consts.IDLE)
    {
      if (tenant_toggle_sales_rep_brand_listener.status === app_consts.LOADING)
      {
        setToggleLoading(true);
      } else
      {
        setToggleLoading(false);
        if (tenant_toggle_sales_rep_brand_listener.status === app_consts.FAIL)
        {
          if (!view_sales_rep_allowed_brands_modal)
          {
            messageToast(tenant_toggle_sales_rep_brand_listener.message, app_consts.FAIL);
          }
          setToggleRoleError(tenant_toggle_sales_rep_brand_listener.message);
        } else if (tenant_toggle_sales_rep_brand_listener.status === app_consts.SUCCESS)
        {
          if (!view_sales_rep_allowed_brands_modal)
          {
            messageToast(TENANT_TOGGLE_SALES_REP_BRAND_SUCCESS_MSG, app_consts.SUCCESS);
          }
          setPageData({ ...page_data, sales_rep: tenant_toggle_sales_rep_brand_listener.data });
        }
        dispatch(reset_tenant_toggle_sales_rep_brand());
      }
    }
  }, [tenant_toggle_sales_rep_brand_listener]);

  const open_view_sales_rep_allowed_brands_modal = (brand) => {
    setSalesRepAllowedBrandsModal(true);
    setSelectedAllowedBrand(brand);
  };

  const close_view_sales_rep_allowed_brands_modal = () => {
    setSalesRepAllowedBrandsModal(false);
    setSelectedAllowedBrand('');
  };

  const handleCustomRange = () => {
    setShowPicker(!showPicker);
  };


  const handleDateChange = (dates) => {
    const [start, end] = dates;

    setSelectedRange([start, end]); // This updates the calendar UI

    if (start && end)
    {
      setFormData({
        ...form_data,
        order_start_date: moment(start).format("YYYY-MM-DD 00:00:00"),
        order_end_date: moment(end).format("YYYY-MM-DD 23:59:59"),
      });
    }
  };

  const handleApply = () => {
    if (selectedRange.length === 2)
    {
      setRetrievalType(1);
      retrieve_page_data(true);
      setShowPicker(false);
    }
  };

  return (
    <>
      <Head title="Sales Rep Details - Regular"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Sales Rep / <strong className="text-primary small">{page_data?.sales_rep?.name || "--"}</strong>
              </BlockTitle>
              <BlockDes className="text-soft">
                <ul className="list-inline">
                  <li>
                    Last Login: <span className="text-base">{page_data?.sales_rep?.last_login ? moment(page_data?.sales_rep.last_login).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                  </li>
                </ul>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="light"
                outline
                className="bg-white d-none d-sm-inline-flex"
                onClick={() => navigate(-1)}
              >
                <Icon name="arrow-left"></Icon>
                <span>Back</span>
              </Button>
              <a
                href="#back"
                onClick={(ev) => {
                  ev.preventDefault();
                  navigate(-1);
                }}
                className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
              >
                <Icon name="arrow-left"></Icon>
              </a>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Sales Rep Details..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data ?
                        <>
                          <Block>
                            <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                            {
                              activeCardTab === "Main Info" && (
                                <>
                                  <div className="card-inner bg-white">
                                    <Block>
                                      <BlockHead>
                                        <BlockTitle tag="h5">Main Information</BlockTitle>
                                      </BlockHead>
                                      <div className="profile-ud-list">
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Name</span>
                                            <span className="profile-ud-value">{page_data?.sales_rep?.name || "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Email Address</span>
                                            <span className="profile-ud-value">{page_data?.sales_rep?.email_address || "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Mobile Number</span>
                                            <span className="profile-ud-value">{page_data?.sales_rep?.mobile_number || "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">TPIN</span>
                                            <span className="profile-ud-value">{page_data?.sales_rep?.tpin || "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Type</span>
                                            <span className="profile-ud-value">{page_data?.sales_rep?.type || "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Date Created</span>
                                            <span className="profile-ud-value">{page_data?.sales_rep?.inserted_at ? moment(page_data?.sales_rep?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                          </div>
                                        </div>
                                        <div className="profile-ud-item">
                                          <div className="profile-ud wider">
                                            <span className="profile-ud-label">Status</span>
                                            <span className="profile-ud-value">
                                              <span className="tb-odr-status">
                                                <Badge
                                                  color={
                                                    page_data?.sales_rep?.status === app_consts.ACTIVE
                                                      ? "success"
                                                      : "danger"
                                                  }
                                                  className="badge-dot"
                                                >
                                                  {page_data?.sales_rep?.status?.toUpperCase() || "--"}
                                                </Badge>
                                              </span></span>
                                          </div>
                                        </div>
                                      </div>
                                    </Block>
                                  </div>
                                </>
                              )
                            }
                            {
                              activeCardTab === "Brands" && (
                                <>
                                  <div className="card-inner">
                                    <Block>
                                      <BlockHead className="mt-4">
                                        <BlockTitle tag="h5">Brands</BlockTitle>
                                      </BlockHead>
                                      {
                                        brands && (
                                          <>
                                            <div className='px-4'>
                                              <Row className="g-3">
                                                {brands?.map((role) => {
                                                  const isSelected = page_data?.sales_rep?.allowed_products?.includes(role);
                                                  const isLoading = toggle_loading && selectedToggleRole === role;
                                                  const hasError = toggle_role_error && selectedToggleRole === role;

                                                  // Get brand data and count of product types
                                                  const brandData = page_data?.sales_rep?.allowed_product_types?.find((b) => b.brand === role);
                                                  const productTypeCount = brandData?.allowed_product_types?.length || 0;

                                                  return (
                                                    <Col key={role} lg="3" md="4" sm="6">
                                                      <div
                                                        className={`card shadow-sm border-0 position-relative p-4 ${isSelected ? "bg-light" : "bg-white"
                                                          }`}
                                                        style={{
                                                          borderRadius: "16px",
                                                          transition: "all 0.3s ease",
                                                          cursor: toggle_loading ? "not-allowed" : "pointer",
                                                          minHeight: "150px",
                                                        }}
                                                      >
                                                        {/* Settings Icon (top-right corner, reserved for future use) */}
                                                        <div
                                                          className="position-absolute top-0 end-0 mt-2 me-2 text-muted"
                                                          style={{
                                                            cursor: toggle_loading ? "not-allowed" : "pointer",
                                                            opacity: 0.8,
                                                            transition: "opacity 0.2s ease",
                                                          }}
                                                          onClick={() => open_view_sales_rep_allowed_brands_modal(role)}
                                                          onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
                                                          onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.8)}
                                                        >
                                                          <em className="icon ni ni-setting-alt fs-5"></em>
                                                        </div>

                                                        {/* Card Content */}
                                                        <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center">
                                                          {isLoading ? (
                                                            <div className="d-flex align-items-center justify-content-center">
                                                              <Spinner size="sm" color="primary" className="mr-2" />
                                                              <span className="fw-semibold small text-secondary">
                                                                {formatToSentenceCase(role)}
                                                              </span>
                                                            </div>
                                                          ) : (
                                                            <>
                                                              <em
                                                                className={`icon ni ${isSelected ? "ni-check-circle text-success" : ""
                                                                  } fs-2 mb-2`}
                                                              ></em>

                                                              <h6
                                                                className="fw-semibold text-dark mb-1"
                                                                style={{ fontSize: "0.95rem" }}
                                                              >
                                                                {formatToSentenceCase(role)}
                                                              </h6>

                                                              {/* Product Type Count */}
                                                              <small className="text-muted mb-1">
                                                                {productTypeCount} Product Type
                                                                {productTypeCount === 1 ? "" : "s"}
                                                              </small>

                                                              {/* Toggle Switch */}
                                                              {(user_info?.roles?.includes(app_consts.ADMINISTRATOR) ||
                                                                user_info?.roles?.includes(app_consts.UPDATE_BUDGET_ALLOCATION)) ? (
                                                                <div className="custom-control custom-switch mt-1">
                                                                  {isLoading ? (
                                                                    <Spinner size="sm" color="primary" className="mr-2" />
                                                                  ) : (
                                                                    <>
                                                                      <input
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        name={role}
                                                                        id={role}
                                                                        disabled={toggle_loading}
                                                                        checked={isSelected}
                                                                        onClick={() => toggle_brand(role)}
                                                                      />
                                                                      <label
                                                                        className={`custom-control-label fs16 ${isSelected ? "" : "text-muted"
                                                                          }`}
                                                                        htmlFor={role}
                                                                      >
                                                                        {isSelected ? "Enabled" : "Disabled"}
                                                                      </label>
                                                                    </>
                                                                  )}
                                                                </div>
                                                              ) : (
                                                                <div className="mt-1">
                                                                  <span
                                                                    className={`fs-16 ${isSelected ? "" : "text-muted"}`}
                                                                  >
                                                                    {isSelected ? "Enabled" : "Disabled"}
                                                                  </span>
                                                                </div>
                                                              )}
                                                            </>
                                                          )}

                                                          {hasError && (
                                                            <div className="mt-2 text-danger small">
                                                              <em className="icon ni ni-alert-circle me-1"></em>
                                                              {toggle_role_error}
                                                            </div>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </Col>
                                                  );
                                                })}
                                              </Row>
                                            </div>
                                          </>
                                        )
                                      }
                                    </Block>
                                  </div>

                                  <ViewSalesRepsAllowedBrandsModal tenant_info={tenant_info} user_info={user_info} isOpen={view_sales_rep_allowed_brands_modal} closeModal={close_view_sales_rep_allowed_brands_modal} mainPageData={page_data} data={selected_allowed_brand} setData={setPageData} />
                                </>
                              )
                            }
                            {
                              activeCardTab === "Agencies" && (
                                <>
                                  <div className="card-inner">
                                    <Block>
                                      <BlockHead className="mt-4">
                                        <BlockTitle tag="h5">Agencies</BlockTitle>
                                      </BlockHead>
                                      {
                                        page_data?.agencies && page_data?.agencies?.length > 0 ?
                                          <>
                                            <div className="nk-tb-list is-separate is-medium mb-3">
                                              <DataTableHead className="nk-tb-item">
                                                <DataTableRow><span className="sub-text">Name</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Mobile Number</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Email Address</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Orders by Sales Rep</span></DataTableRow>
                                                <DataTableRow size="md"><span className="sub-text">Status</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Action</span></DataTableRow>
                                              </DataTableHead>

                                              {currentAgencyItems.length > 0 &&
                                                currentAgencyItems.map((item) => (
                                                  <DataTableItem key={item.id}>
                                                    <DataTableRow>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          <span className="tb-lead">
                                                            {addThreeDots(item?.name || "--", 30)}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <span className="tb-lead">{item?.mobile_number || "--"}</span>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <span className="tb-lead">{item?.email_address || "--"}</span>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          <span className="tb-lead">{item?.order_count || "0"}</span>
                                                        </div>
                                                      </div>
                                                    </DataTableRow>
                                                    <DataTableRow size="md">
                                                      <Badge
                                                        color={
                                                          item?.status === app_consts.ACTIVE
                                                            ? "success"
                                                            : "warning"
                                                        }
                                                        className="badge-dot"
                                                      >
                                                        {item?.status
                                                          ? formatToSentenceCase(item?.status)?.toUpperCase()
                                                          : "--"}
                                                      </Badge>
                                                    </DataTableRow>
                                                    <DataTableRow className="nk-tb-col-tools">
                                                      <div className="tb-odr-btns d-none d-sm-inline">
                                                        <Button color="primary" size="sm" className="btn btn-dim" onClick={() => open_view_sales_rep_modal(item?.id)}>
                                                          View
                                                        </Button>
                                                      </div>
                                                      <Button className="btn-pd-auto d-sm-none" onClick={() => open_view_sales_rep_modal(item?.id)}>
                                                        <Icon name="chevron-right"></Icon>
                                                      </Button>
                                                    </DataTableRow>
                                                  </DataTableItem>
                                                ))}
                                            </div>
                                            {currentAgencyItems.length > 0 && (
                                              <div className="mt-3">
                                                <PaginationComponent
                                                  itemPerPage={itemPerPage}
                                                  totalItems={page_data?.agencies?.length}
                                                  paginate={agencies_paginate}
                                                  currentPage={currentAgencyPage}
                                                />
                                              </div>
                                            )}
                                            <AgencyViewSalesRepDetailsModal isOpen={view_sales_rep_modal} closeModal={close_view_sales_rep_modal} tenant_info={tenant_info} user_info={user_info} successFunction={retrieve_page_data} data={{ id: sales_rep_id, sales_rep_id: id }} />
                                          </>
                                          :
                                          <>
                                            <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Agencies Found."} />
                                          </>
                                      }
                                    </Block>
                                  </div>
                                </>
                              )
                            }
                            {
                              activeCardTab === "Orders" && (
                                <>
                                  <div className="card-inner">
                                    <Block>
                                      <BlockHead className="mt-4">
                                        <BlockBetween>
                                          <BlockHeadContent>
                                            <BlockTitle page>Orders</BlockTitle>
                                            <BlockDes className="text-soft">
                                              <p>{!(loading || error) && `Orders ${page_data?.orders?.length}`}</p>
                                            </BlockDes>
                                          </BlockHeadContent>
                                          {!(loading || error) && (
                                            <BlockHeadContent>
                                              <div className="toggle-wrap nk-block-tools-toggle">
                                                <a
                                                  href="#more"
                                                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                                                  onClick={(ev) => {
                                                    ev.preventDefault();
                                                    updateSm(!sm);
                                                  }}
                                                >
                                                  <Icon name="more-v"></Icon>
                                                </a>
                                                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                                                  <ul className="nk-block-tools g-3">
                                                    <li>
                                                      <div className="form-control-wrap">
                                                        <div className="form-icon form-icon-right">
                                                          <Icon name="search"></Icon>
                                                        </div>
                                                        <Input
                                                          type="text"
                                                          className="form-control"
                                                          id="default-04"
                                                          value={ordersSearchTerm}
                                                          onChange={e => {
                                                            setOrdersSearchTerm(e.target.value);
                                                            setCurrentOrdersPage(1);
                                                          }}
                                                          placeholder="Search Orders..."
                                                        />
                                                      </div>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </BlockHeadContent>
                                          )}
                                        </BlockBetween>
                                      </BlockHead>

                                      {
                                        page_data?.orders && page_data?.orders.length > 0 ?
                                          <>
                                            <div className="nk-tb-list is-separate is-medium mb-3">
                                              <DataTableHead className="nk-tb-item">
                                                <DataTableRow><span className="sub-text">Order</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Behalf Of</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">No Of Products</span></DataTableRow>
                                                <DataTableRow size="lg"><span className="sub-text">Date Created</span></DataTableRow>
                                                <DataTableRow size="md"><span className="sub-text">Order Date Type</span></DataTableRow>
                                                <DataTableRow size="md"><span className="sub-text">Status</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Action</span></DataTableRow>
                                              </DataTableHead>

                                              {currentOrderItems.length > 0 &&
                                                currentOrderItems.map((item) => (
                                                  <DataTableItem key={item.id}>
                                                    <DataTableRow>
                                                      <a
                                                        href={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      >
                                                        <div className="user-card">
                                                          <div className="user-info">
                                                            <span className="tb-lead">
                                                              {addThreeDots(item?.order_name || "--", 30)}
                                                            </span>
                                                            <span>{item?.order_ref_number || "--"}</span>
                                                          </div>
                                                        </div>
                                                      </a>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <span className="tb-lead">
                                                        {item?.behalf_of === app_consts.SELF
                                                          ? item?.sales_rep?.name
                                                          : item?.agency?.name}
                                                      </span>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          <span className="tb-lead">{item?.no_of_products || "0"}</span>
                                                          <span>{item?.total_value ? `${formatNumber(item?.total_value)} ZMW` : ""}</span>
                                                        </div>
                                                      </div>
                                                    </DataTableRow>
                                                    <DataTableRow size="md">
                                                      <span className="tb-lead">
                                                        {item?.inserted_at
                                                          ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss")
                                                          : "--"}
                                                      </span>
                                                    </DataTableRow>
                                                    <DataTableRow size="md">
                                                      {item?.order_date_type
                                                        ? formatToSentenceCase(item?.order_date_type)?.toUpperCase()
                                                        : "--"}
                                                    </DataTableRow>
                                                    <DataTableRow size="md">
                                                      <Badge
                                                        color={
                                                          item?.status === app_consts.APPROVED_LOWER ||
                                                            item?.status === app_consts.DISPATCHED_LOWER
                                                            ? "success"
                                                            : "warning"
                                                        }
                                                        className="badge-dot"
                                                      >
                                                        {item?.status
                                                          ? formatToSentenceCase(item?.status)?.toUpperCase()
                                                          : "--"}
                                                      </Badge>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <a
                                                        href={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      >
                                                        <Button color="primary" size="sm" className="btn btn-dim">
                                                          View
                                                        </Button>
                                                      </a>
                                                    </DataTableRow>
                                                  </DataTableItem>
                                                ))}
                                            </div>
                                            {currentOrderItems.length > 0 && (
                                              <div className="mt-3">
                                                <PaginationComponent
                                                  itemPerPage={itemPerPage}
                                                  totalItems={page_data?.orders?.length}
                                                  paginate={orders_paginate}
                                                  currentPage={current_orders_page}
                                                />
                                              </div>
                                            )}
                                          </>
                                          :
                                          <>
                                            <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Orders Found"} />
                                          </>
                                      }
                                    </Block>
                                  </div>
                                </>
                              )
                            }
                            {
                              activeCardTab === "Orders Reports" && (
                                <>

                                  <div className="card-inner">
                                    <Block>
                                      <BlockHead className="mt-4">
                                        <BlockBetween>
                                          <BlockHeadContent>
                                            <BlockTitle page>Orders Reports</BlockTitle>
                                          </BlockHeadContent>
                                        </BlockBetween>
                                      </BlockHead>
                                      <motion.div
                                        className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between flex-wrap bg-light p-3 mb-3"
                                        initial={{ opacity: 0, y: -10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                      >
                                        <div className="mb-2 mb-sm-0">

                                          {/* Toggle Button */}
                                          <div className="d-flex align-items-center mb-2">
                                            <Button color="primary" size="sm" onClick={handleCustomRange}>
                                              {showPicker ? "Cancel" : "Custom Range"}
                                            </Button>
                                          </div>

                                          {/* Conditional Date Range Picker */}
                                          {showPicker && (
                                            <motion.div
                                              initial={{ opacity: 0, y: -10 }}
                                              animate={{ opacity: 1, y: 0 }}
                                              transition={{ duration: 0.3 }}
                                              className="mb-3"
                                            >
                                              <label className="form-label fw-semibold text-muted mb-1">
                                                Select Date Range
                                              </label>

                                              <DatePicker
                                                selected={selectedRange[0]}
                                                onChange={handleDateChange}
                                                startDate={selectedRange[0]}
                                                endDate={selectedRange[1]}
                                                selectsRange
                                                dateFormat="yyyy-MM-dd"
                                                className="form-control"
                                              />

                                              <Button
                                                color="success"
                                                size="sm"
                                                className="mt-2"
                                                onClick={handleApply}
                                                disabled={!form_data?.order_start_date || !form_data?.order_end_date || retriaval_loading}
                                              >
                                                {retriaval_loading ? "Retrieving Data" : "Apply"}
                                              </Button>

                                              {retrievalError && (
                                                <Alert className="my-4" color="danger">
                                                  {retrievalError}
                                                </Alert>
                                              )}
                                            </motion.div>
                                          )}

                                          {/* Display current date info */}
                                          {!showPicker && (
                                            <motion.div
                                              initial={{ opacity: 0, y: -10 }}
                                              animate={{ opacity: 1, y: 0 }}
                                              transition={{ duration: 0.3 }}
                                            >
                                              <motion.div
                                                className="bg-light border-start border-primary ps-3 py-2 mb-3 rounded"
                                                initial={{ opacity: 0, x: -20 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                transition={{ duration: 0.4, delay: 0.1 }}
                                              >
                                                <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                                                  📅 Showing data from{" "}
                                                  <span className="fw-semibold text-dark">
                                                    {form_data?.order_start_date}
                                                  </span>{" "}
                                                  up to{" "}
                                                  <span className="fw-semibold text-dark">
                                                    {form_data?.order_end_date}
                                                  </span>.
                                                </p>
                                              </motion.div>
                                            </motion.div>
                                          )}

                                        </div>
                                      </motion.div>
                                      <div className="nk-tabs nav nav-tabs nav-tabs-mb-icon mt-n1 mb-4">
                                        {orders_reports_tabs.map((tab) => {
                                          const isActive = activeOrderReportTab === tab.tabName;
                                          return (
                                            <button
                                              key={tab.tabName}
                                              onClick={() => setActiveOrderReportTab(tab.tabName)}
                                              className={`nav-link`}
                                              style={{
                                                padding: "0.625rem 1.25rem",
                                                fontSize: "0.875rem",
                                                fontWeight: 500,
                                                borderRadius: "20px",
                                                border: "1px solid transparent",
                                                transition: "all 0.2s ease",
                                                background: isActive ? "#6576ff" : "transparent",
                                                color: isActive ? "#fff" : "#526484",
                                                borderColor: isActive ? "#6576ff" : "#e5e9f2",
                                                boxShadow: isActive ? "0 4px 12px rgba(102, 118, 255, 0.2)" : "none",
                                                cursor: "pointer",
                                                marginRight: "0.5rem"
                                              }}
                                              onMouseEnter={(e) => {
                                                if (!isActive)
                                                {
                                                  e.target.style.background = "#f5f6fa";
                                                  e.target.style.borderColor = "#d4d9e4";
                                                }
                                              }}
                                              onMouseLeave={(e) => {
                                                if (!isActive)
                                                {
                                                  e.target.style.background = "transparent";
                                                  e.target.style.borderColor = "#e5e9f2";
                                                }
                                              }}
                                            >
                                              {tab.tabName}
                                            </button>
                                          );
                                        })}
                                      </div>
                                      <Row className="g-gs" style={{ marginBottom: '20px' }}>
                                        {
                                          activeOrderReportTab === "Summary" && (
                                            <>
                                              <SalesRepDetailsOrdersReportsSummary data={{ ...page_data?.order_reports_data, sales_rep: page_data?.sales_rep }} />
                                            </>
                                          )
                                        }
                                        {
                                          activeOrderReportTab === "Products" && (
                                            <>
                                              <SalesRepDetailsOrderReportsProducts tabName={activeOrderReportTab} start_date={form_data?.order_start_date} end_date={form_data?.order_end_date} tenant_info={tenant_info} user_info={user_info} sales_rep_id={id} data={page_data} />
                                            </>
                                          )
                                        }
                                        {
                                          activeOrderReportTab === "Orders" && (
                                            <>
                                              <SalesRepDetailsOrderReportsOrders tabName={activeOrderReportTab} start_date={form_data?.order_start_date} end_date={form_data?.order_end_date} tenant_info={tenant_info} user_info={user_info} sales_rep_id={id} data={page_data} />
                                            </>
                                          )
                                        }
                                      </Row>
                                    </Block>
                                  </div>
                                </>
                              )
                            }
                            {
                              activeCardTab === "Budget Allocations" && (
                                <>
                                  <div className="card-inner">
                                    <Block>
                                      <BlockHead className="mt-4">
                                        <BlockBetween>
                                          <BlockHeadContent>
                                            <BlockTitle page>Budget Allocations</BlockTitle>
                                          </BlockHeadContent>
                                        </BlockBetween>
                                      </BlockHead>

                                      {
                                        page_data?.budget_allocations && page_data?.budget_allocations.length > 0 ?
                                          <>
                                            <div className="nk-tb-list is-separate is-medium mb-3">
                                              <DataTableHead className="nk-tb-item">
                                                <DataTableRow><span className="sub-text">Name</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Agency</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Start Date</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">End Date</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Allocated Value</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Used Value</span></DataTableRow>
                                                <DataTableRow size="lg"><span className="sub-text">Remaining Value</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Action</span></DataTableRow>
                                              </DataTableHead>

                                              {currentAllocationItems.length > 0 &&
                                                currentAllocationItems.map((item) => (
                                                  <DataTableItem key={item.id}>
                                                    <DataTableRow>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          <span className="tb-lead">
                                                            {addThreeDots(item?.budget_allocation?.name || "--", 30)}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          <span className="tb-lead">
                                                            {addThreeDots(item?.agency?.name || "--", 30)}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          <span className="tb-lead">
                                                            {item?.budget_allocation?.start_date
                                                              ? moment(item?.budget_allocation?.start_date).format("YYYY-MM-DD HH:mm:ss")
                                                              : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          <span>{item?.budget_allocation?.end_date
                                                            ? moment(item?.budget_allocation?.end_date).format("YYYY-MM-DD HH:mm:ss")
                                                            : "--"} </span>
                                                        </div>
                                                      </div>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <span className="tb-lead">
                                                        {item?.sales_bud_allocation?.value ? `${formatNumber(item?.sales_bud_allocation?.value)} ZMW` : ""}
                                                      </span>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          {item?.sales_bud_allocation?.used ? `${formatNumber(item?.sales_bud_allocation?.used)} ZMW` : ""}
                                                        </div>
                                                      </div>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          {item?.sales_bud_allocation?.remaining ? `${formatNumber(item?.sales_bud_allocation?.remaining)} ZMW` : ""}
                                                        </div>
                                                      </div>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <Button color="primary" size="sm" className="btn btn-dim" onClick={() => open_view_sales_rep_budget_allocation_details(item?.sales_bud_allocation?.id)}>
                                                        View
                                                      </Button>
                                                    </DataTableRow>
                                                  </DataTableItem>
                                                ))}
                                            </div>
                                            {currentAllocationItems.length > 0 && (
                                              <div className="mt-3">
                                                <PaginationComponent
                                                  itemPerPage={itemPerPage}
                                                  totalItems={page_data?.budget_allocations?.length}
                                                  paginate={allocations_paginate}
                                                  currentPage={current_allocations_page}
                                                />
                                              </div>
                                            )}
                                          </>
                                          :
                                          <>
                                            <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Budget Allocations Found."} />
                                          </>
                                      }
                                    </Block>
                                  </div>

                                  <ViewSalesRepBudgetAllocationDetails closeModal={close_view_sales_rep_budget_allocation_details} tenant_info={tenant_info} user_info={user_info} successFunction={retrieve_page_data} data={{ id: selected_sales_rep_budget_allocation }} isOpen={view_sales_rep_budget_allocation_details} />
                                </>
                              )
                            }
                            {
                              activeCardTab === "Audit Trails" && (
                                <>
                                  <div className="card-inner">
                                    <Block>
                                      <BlockHead className="mt-4">
                                        <BlockBetween>
                                          <BlockHeadContent>
                                            <BlockTitle page>Audit Trails</BlockTitle>
                                          </BlockHeadContent>
                                        </BlockBetween>
                                      </BlockHead>

                                      {
                                        page_data?.audit_trails && page_data?.audit_trails.length > 0 ?
                                          <>
                                            <div className="nk-tb-list is-separate is-medium mb-3">
                                              <DataTableHead className="nk-tb-item">
                                                <DataTableRow><span className="sub-text">Message</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Audit Type</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Status</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Timestamp</span></DataTableRow>
                                                <DataTableRow><span className="sub-text">Action</span></DataTableRow>
                                              </DataTableHead>

                                              {currentAuditItems.length > 0 &&
                                                currentAuditItems.map((item) => (
                                                  <DataTableItem key={item.id}>
                                                    <DataTableRow>
                                                      <span>{item?.message ? addThreeDots(item?.message, 60) : "--"}</span>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <span>{item?.audit_type?.toUpperCase() || "--"}</span>
                                                    </DataTableRow>
                                                    <DataTableRow size="md">
                                                      <span className="tb-odr-status">
                                                        <Badge
                                                          color={
                                                            item?.status === app_consts.SUCCESS_LOWER
                                                              ? "success"
                                                              : item?.status === app_consts.REQUEST_LOWER
                                                                ? "warning"
                                                                : "danger"
                                                          }
                                                          className="badge-dot"
                                                        >
                                                          {item?.status?.toUpperCase() || "--"}
                                                        </Badge>
                                                      </span>
                                                    </DataTableRow>
                                                    <DataTableRow>
                                                      <span>{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                    </DataTableRow>
                                                    <DataTableRow className="nk-tb-col-tools">
                                                      <div className="tb-odr-btns d-none d-sm-inline">
                                                        <Link /* to={`/${tenant_info.url_prefix}/employees/${item?.account?.mobile_number}`} */>
                                                          <Button color="primary" size="sm" className="btn btn-dim" onClick={() => view_audit_trail(item?.id)}>
                                                            View
                                                          </Button>
                                                        </Link>
                                                      </div>
                                                      <Button className="btn-pd-auto d-sm-none" onClick={() => view_audit_trail(item?.id)}>
                                                        <Icon name="chevron-right"></Icon>
                                                      </Button>
                                                    </DataTableRow>
                                                  </DataTableItem>
                                                ))}
                                            </div>
                                            {currentAuditItems.length > 0 && (
                                              <div className="mt-3">
                                                <PaginationComponent
                                                  itemPerPage={itemPerPage}
                                                  totalItems={page_data?.audit_trails?.length}
                                                  paginate={audits_paginate}
                                                  currentPage={current_audits_page}
                                                />
                                              </div>
                                            )}
                                            {/* View Audit Trail Modal */}

                                            {/* Page Modal */}
                                            <Modal isOpen={audit_trails_modal} toggle={close_view_audit_modal} className="modal-dialog-centered" size={"lg"}>
                                              <ModalHeader toggle={close_view_audit_modal}>Audit Trail Details</ModalHeader>
                                              <ModalBody>
                                                <Row className="g-4">

                                                  <LabelText text={selected_audit?.message || "--"} label="Message" />
                                                  <LabelText text={selected_audit?.audit_type?.toUpperCase() || "--"} label="Audit Type" />
                                                  <LabelText
                                                    text={selected_audit?.status?.toUpperCase() || "--"}
                                                    label="Status"
                                                    badgeStat
                                                    badgeColor={
                                                      selected_audit?.status === app_consts.SUCCESS_LOWER
                                                        ? "success"
                                                        : selected_audit?.status === app_consts.REQUEST_LOWER
                                                          ? "warning"
                                                          : "danger"
                                                    }
                                                  />
                                                  <LabelText text={selected_audit?.inserted_at ? moment(selected_audit?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"} label="Timestamp" />
                                                  {selected_audit?.data &&
                                                    (
                                                      <>
                                                        <div className="mt-4 ">
                                                          <BlockHead>
                                                            <BlockTitle tag="h6">Audit Data</BlockTitle>
                                                          </BlockHead>
                                                        </div>
                                                        {selected_audit?.audit_trail?.data &&
                                                          Object.entries(selected_audit.audit_trail.data)
                                                            .filter(([_, value]) => !Array.isArray(value)) // Skip arrays
                                                            .map(([key, value]) => (
                                                              <LabelText key={formatToSentenceCase(key)} text={String(value)} label={key} />
                                                            ))}
                                                      </>
                                                    )
                                                  }
                                                </Row>
                                              </ModalBody>
                                            </Modal>
                                          </>
                                          :
                                          <>
                                            <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Audit Trails Found."} />
                                          </>
                                      }
                                    </Block>
                                  </div>
                                </>
                              )
                            }
                          </Block>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"Sales Rep Data Not Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>

    </>
  );
};

export default SalesRepsDetails;;